var MODEL_SPECIFIC_FAQS = [{
  question_ar: "كم يبدأ القسط الشهري لتمويل {name}؟",
  answer_ar: "يبدأ القسط الشهري لتمويل {name} من {monthly_installment} ريال تقريبًا، وقد يختلف المبلغ النهائي بحسب سنة الصنع، وحالة المركبة، والفئة المختارة، وسياسات التمويل المعتمدة.",
  question_en: "What is the starting monthly installment for financing a {name}?",
  answer_en: "The monthly installment for financing a {name} starts from SAR {monthly_installment} approximately. The final amount may vary depending on the model year, vehicle condition, selected trim, and the approved financing terms.",
  requiresModel: true
}, {
  question_ar: "ما هي مدة التقسيط المتاحة لسيارة {name}؟",
  answer_ar: "مدة التقسيط المتاحة لسيارة {name} تصل إلى 60 شهرًا، وهي من مدد التمويل المناسبة للراغبين في توزيع قيمة السيارة على أقساط شهرية ميسرة.",
  question_en: "What is the available financing term for a {name}?",
  answer_en: "The available financing term for a {name} is up to 60 months, making it a suitable option for customers looking for flexible monthly payments.",
  requiresModel: true
}, {
  question_ar: "ما هي قيمة الدفعة الأولى لسيارة {name}؟",
  answer_ar: "قيمة الدفعة الأولى لسيارة {name} تبدأ من {first_payment} ريال، ما يعني إمكانية الحصول على تمويل بدون دفعة أولى في بعض الحالات، حسب أهلية العميل وشروط الجهة التمويلية.",
  question_en: "What is the down payment amount for a {name}?",
  answer_en: "The down payment for a {name} starts from SAR {first_payment}, which means financing may be available with no down payment in some cases, depending on customer eligibility and financing approval.",
  requiresModel: true
}, {
  question_ar: "ما هي قيمة الدفعة الأخيرة لسيارة {name}؟",
  answer_ar: "قيمة الدفعة الأخيرة لسيارة {name} تبدأ من {last_payment} ريال تقريبًا، وقد تختلف بحسب سعر السيارة، وخطة التمويل، والفئة المختارة.",
  question_en: "What is the final payment amount for a {name}?",
  answer_en: "The final payment for a {name} starts from SAR {last_payment} approximately, and may vary depending on the vehicle price, financing plan, and selected trim.",
  requiresModel: true
}, {
  question_ar: "ما هو سعر الكاش التقديري لسيارة {name}؟",
  answer_ar: "سعر الكاش التقديري لسيارة {name} يبدأ من حوالي {cash_price} ريال، مع ملاحظة أن السعر يختلف حسب موديل السيارة، وتجهيزاتها، وحالتها العامة.",
  question_en: "What is the estimated cash price of a {name}?",
  answer_en: "The estimated cash price of a {name} starts from around SAR {cash_price}, although the actual price may differ based on the model year, specifications, and overall vehicle condition.",
  requiresModel: true
}, {
  question_ar: "ما هي شروط تقسيط سيارات {name}؟",
  answer_ar: "شروط تقسيط سيارات {name} تشمل عادة أن يكون العميل على رأس العمل في جهة حكومية لمدة لا تقل عن شهر، أو في جهة خاصة لمدة لا تقل عن 90 يومًا، وألا يكون متعثرًا أو مدرجًا في سمة، وأن يكون الراتب أكثر من 2,500 ريال، وأن تكون السيارة متاحة للتمويل.",
  question_en: "What are the financing requirements for {name} cars?",
  answer_en: "The financing requirements for {name} cars usually include being employed in a government sector for at least one month or in the private sector for at least 90 days, having no credit default or negative SIMAH record, earning more than SAR 2,500, and choosing a vehicle that is eligible for financing.",
  requiresModel: true
}, {
  question_ar: "ما هي الأوراق المطلوبة لتقسيط سيارات {name}؟",
  answer_ar: "الأوراق المطلوبة لتقسيط سيارات {name} تشمل هوية الأحوال الشخصية، ورخصة قيادة سارية المفعول، وتعريف راتب لا يزيد عمره عن شهر، إضافة إلى برنت تأمينات إذا كان المتقدم يعمل في القطاع الخاص.",
  question_en: "What documents are required to finance a {name}?",
  answer_en: "The documents required to finance a {name} usually include a national ID, a valid driver's license, a salary certificate issued within the last month, and a social insurance printout if the applicant works in the private sector.",
  requiresModel: true
}, {
  question_ar: "هل جميع سيارات {name} لها نفس تفاصيل التمويل؟",
  answer_ar: "لا، ليست جميع سيارات {name} لها نفس تفاصيل التمويل، لأن قيمة القسط، والدفعة الأولى، والدفعة الأخيرة، وسعر الكاش تختلف بحسب سنة الصنع، وحالة المركبة، والفئة المختارة، والجهة التمويلية.",
  question_en: "Do all {name} cars have the same financing details?",
  answer_en: "No, not all {name} cars have the same financing details, because the monthly payment, down payment, final payment, and cash price can vary depending on the model year, vehicle condition, selected trim, and financing provider.",
  requiresModel: true
}, {
  question_ar: "هل يمكن تقسيط سيارات {name} وأنا على التزام في بنك؟",
  answer_ar: "يمكن تقسيط سيارات {name} وأنت على التزام في بنك في بعض الحالات، لكن ذلك يعتمد على نسبة الاستقطاع، والراتب الشهري، والسجل الائتماني، وسياسة الجهة التمويلية في دراسة الطلب والموافقة عليه.",
  question_en: "Can I finance a {name} if I already have a bank commitment?",
  answer_en: "Yes, it may be possible to finance a {name} even if you already have a bank commitment, but approval depends on your debt burden ratio, monthly salary, credit history, and the financing provider's policy.",
  requiresModel: true
}, {
  question_ar: "ما هي خطوات وآلية تقسيط سيارات {name}؟",
  answer_ar: "خطوات وآلية تقسيط سيارات {name} تبدأ باختيار السيارة المناسبة، ثم تقديم طلب التمويل، وبعدها انتظار الموافقة البنكية، ثم استكمال تسجيل السيارة وتأمينها، وأخيرًا يتم تسليم السيارة للعميل بعد إتمام الإجراءات.",
  question_en: "What are the steps and process for financing a {name}?",
  answer_en: "The steps and process for financing a {name} usually start with selecting the car, then submitting the financing application, waiting for bank approval, completing registration and insurance, and finally receiving the car after the process is completed.",
  requiresModel: true
}];
var GENERAL_FAQS = [{
  question_ar: "ما خطوات التقسيط عن طريق تمارا؟",
  answer_ar: "تقسيط السيارات عن طريق تمارا يتم بخطوات بسيطة وسهلة. تبدأ باختيار الخطة المناسبة لك عند الدفع، ثم تدخل بيانات بطاقتك وتسدد أول دفعة مباشرة. بعد ذلك يمكنك متابعة الدفعات القادمة وسدادها من خلال تطبيق تمارا، كما تصلك تنبيهات قبل موعد استحقاق كل دفعة حتى تبقى على اطلاع دائم وتتجنب التأخير.",
  question_en: "What are the steps for installment payments through Tamara?",
  answer_en: "Car installment payments through Tamara are simple and easy. Start by selecting the suitable payment plan at checkout, then enter your card details and pay the first installment. After that, you can track and pay upcoming installments through the Tamara app, while receiving reminders before each due date.",
  requiresModel: false
}, {
  question_ar: "هل شركة سيارة هي الممول للسيارات؟",
  answer_ar: "شركة سيارة توفر لك السيارة وتقوم بإنهاء كافة الإجراءات بدءاً من رفع أوراقك لجهات التمويل إلى أن تستلم سيارتك لكن التمويل يتم من خلال البنوك وشركات التمويل.",
  question_en: "Is Syarah the financing provider for installment cars?",
  answer_en: "Syarah provides the vehicle and handles all procedures from submitting your documents to financing entities until you receive your car. The actual financing is provided through banks and finance companies.",
  requiresModel: false
}, {
  question_ar: "هل التمويل متوافق مع الشريعة الإسلامية؟",
  answer_ar: "نعم، جميع برامج التمويل في سـيارة تتم عن طريق بنوك وشركات تمويل معتمدة من البنك المركزي السعودي وتقدم صيغ تمويل متوافقة مع الشريعة الإسلامية (مثل المرابحة).إحنا في سـيارة فقط نسهّل لك تقديم الطلب ومتابعته، والتمويل يتم مباشرة مع الجهة الممولة.",
  question_en: "Is the financing Shariah-compliant?",
  answer_en: "Yes, all financing programs through Syarah are provided by banks and finance companies licensed by the Saudi Central Bank and offer Shariah-compliant finance structures such as Murabaha.",
  requiresModel: false
}, {
  question_ar: "هل يمكنني تقديم الطلب في حالة وجود مخالفات؟",
  answer_ar: "ينبغي عدم وجود أي سجل مخالفات قبل توقيع العقد.",
  question_en: "Can I apply if I have traffic violations?",
  answer_en: "There should be no outstanding traffic violations before signing the contract.",
  requiresModel: false
}, {
  question_ar: "هل يشترط وجود دفعة أولى؟",
  answer_ar: "يعتمد ذلك على وضعك الائتماني (الراتب والالتزامات).",
  question_en: "Is a down payment required?",
  answer_en: "This depends on your credit profile, including salary level and existing financial commitments.",
  requiresModel: false
}, {
  question_ar: "هل يشترط وجود دفعة أخيرة؟",
  answer_ar: "الدفعة الأخير غير الزامية إلا في حال وجود التزامات على العميل, ويمكن تخفيض او زيادة الدفعة الأخيرة حتى 45% حسب رغبة العميل.",
  question_en: "Is a final payment required?",
  answer_en: "A final payment is not mandatory unless the customer has existing obligations. It can also be reduced or increased up to 45% depending on the customer's preference.",
  requiresModel: false
}];
function replaceVariables(text, ctx) {
  var _ctx$cheapestCarPrice;
  var nameField = ctx.lang === 'en' ? 'name_en' : 'name';
  var makeName = ctx.make ? ctx.make[nameField] || ctx.make.name : '';
  var modelName = ctx.model ? ctx.model[nameField] || ctx.model.name : '';
  var name = ctx.model ? "".concat(makeName, " ").concat(modelName).trim() : makeName;
  var result = text.replaceAll('{name}', name);
  if ((_ctx$cheapestCarPrice = ctx.cheapestCarPriceDetails) !== null && _ctx$cheapestCarPrice !== void 0 && _ctx$cheapestCarPrice.finance_price) {
    var _ctx$cheapestCarPrice3;
    var _ctx$cheapestCarPrice2 = ctx.cheapestCarPriceDetails.finance_price,
      first_payment = _ctx$cheapestCarPrice2.first_payment,
      last_payment = _ctx$cheapestCarPrice2.last_payment,
      monthly_installment = _ctx$cheapestCarPrice2.text;
    var cash_price = ((_ctx$cheapestCarPrice3 = ctx.cheapestCarPriceDetails.vat_price) === null || _ctx$cheapestCarPrice3 === void 0 ? void 0 : _ctx$cheapestCarPrice3.text) || '';
    result = result.replaceAll('{monthly_installment}', monthly_installment).replaceAll('{first_payment}', first_payment).replaceAll('{last_payment}', last_payment).replaceAll('{cash_price}', cash_price);
  }
  return result;
}
export function getFinancingFAQs(ctx) {
  var _ctx$cheapestCarPrice4;
  var hasModel = !!(ctx.model || ctx.make);
  var hasPriceDetails = !!((_ctx$cheapestCarPrice4 = ctx.cheapestCarPriceDetails) !== null && _ctx$cheapestCarPrice4 !== void 0 && _ctx$cheapestCarPrice4.finance_price);
  var faqs = [];
  if (hasModel && hasPriceDetails) {
    MODEL_SPECIFIC_FAQS.forEach(function (faq) {
      var question = ctx.lang === 'ar' ? faq.question_ar : faq.question_en;
      var answer = ctx.lang === 'ar' ? faq.answer_ar : faq.answer_en;
      faqs.push({
        question: replaceVariables(question, ctx),
        answer: replaceVariables(answer, ctx)
      });
    });
  } else if (hasModel) {
    MODEL_SPECIFIC_FAQS.filter(function (faq) {
      var text = ctx.lang === 'ar' ? faq.answer_ar : faq.answer_en;
      return !text.includes('{monthly_installment}') && !text.includes('{first_payment}') && !text.includes('{last_payment}') && !text.includes('{cash_price}');
    }).forEach(function (faq) {
      var question = ctx.lang === 'ar' ? faq.question_ar : faq.question_en;
      var answer = ctx.lang === 'ar' ? faq.answer_ar : faq.answer_en;
      faqs.push({
        question: replaceVariables(question, ctx),
        answer: replaceVariables(answer, ctx)
      });
    });
  }
  GENERAL_FAQS.forEach(function (faq) {
    var question = ctx.lang === 'ar' ? faq.question_ar : faq.question_en;
    var answer = ctx.lang === 'ar' ? faq.answer_ar : faq.answer_en;
    faqs.push({
      question: question,
      answer: answer
    });
  });
  return faqs;
}
export function generateFinancingFAQSchema(ctx) {
  var faqs = getFinancingFAQs(ctx);
  if (!faqs.length) return '';
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    inLanguage: ctx.lang,
    mainEntity: faqs.map(function (faq) {
      return {
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      };
    })
  });
}